import axios from "axios";
import { ALT_DOMAIN_ID, API_HOST } from "@/core/variables";
import { SkillCreate, SkillUpdate } from "@/model";

class SkillRepository {
    find = async (agentId: number, keyword?: string, searchType?: "intent" | "intentSentence") => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills`, {
                params: {
                    agent_id: agentId,
                }
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    findWithIntent = async (agentId: number, keyword?: string, searchType?: "intent" | "intentSentence") => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills`, {
                params: {
                    agent_id: agentId,
                    keyword: keyword,
                    search_type: searchType === "intent" ? "intent_name" : "intent_sentence"
                }
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };
    
    delete = async (agentId: number, skillId: number) => {
        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };
    
    create = async (agentId: number, form: SkillCreate) => {
        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills`, {
                ...form
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };
    
    update = async (agentId: number, skillId: number, form: SkillUpdate) => {
        return axios
            .put(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}`, {
                ...form
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    deleteAll = async (agentId: number) => {
        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    import = async (agentId: number, file: File, isCleanImport?: boolean) => {
        const form = new FormData();
        const is_clean_import = isCleanImport ? '1' : '0';
        form.append("is_clean_import", is_clean_import);
        form.append("file", file);

        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/intents/import`, form)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    export = (agentId: number, ids?: string[]) => {
        const params = new URLSearchParams();
        if (ids?.length) {
            ids.forEach(id => params.append("ids", id));
        }
        window.open(`${API_HOST}/v1/agents/${agentId}/intents/export${ids?.length ? `?${params}` : ''}`);
    };
}

const skillRepository = new SkillRepository();
export default skillRepository;
